import React from "react";
import { useNavigate } from "react-router-dom";
import Edit2FillIcon from "remixicon-react/Edit2FillIcon";

const FaqListItem = (props: any) => {
    const navigate = useNavigate()
    const { data } = props

    const updateFbtNavigateHandler = (id: any) => {
        navigate(`/faq/${id}`)
    }

    if (!data.length) {
        return (
            <tr>
                <td colSpan={4} className="px-4 py-12 text-center text-xs text-gray-500">No FAQ schemas found.</td>
            </tr>
        )
    }

    return (
        <>
            {data.map((_d: any) =>
                <tr key={_d.categoryCode} className='[&:nth-child(odd)]:bg-[#f7f7f7]'>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F] font-medium">{_d.categoryCode}</td>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F]">{_d.categoryName}</td>
                    <td className="px-4 py-3 text-left text-xs text-[#3F3F3F]">{_d.number}</td>
                    <td className="px-4 py-3">
                        <button
                            onClick={() => updateFbtNavigateHandler(_d.categoryCode)}
                            className="text-blue-600 hover:text-blue-800 transition-colors"
                            title="Update"
                        >
                            <Edit2FillIcon size={16} />
                        </button>
                    </td>
                </tr>
            )}
        </>
    )
}
export default FaqListItem;
